<template>
  <div class="p-4">
    <h2 class="text-lg font-bold mb-2">Маятник: ускорение AY</h2>
    <div class="ct-chart ct-major-twelfth"></div>
  </div>
</template>

<script setup>
import { onMounted, onBeforeUnmount } from 'vue'
import * as Chartist from 'chartist'
import 'chartist/dist/chartist.min.css'

// Ссылка на API (например, Glitch или твой сервер)
const API_URL = 'https://maiatnik.glitch.me/api/maiatnik'

// Храним последние значения
let chart = null
let interval = null
const maxPoints = 50
const labels = []
const data = []

onMounted(() => {
  // Первичная инициализация графика
  chart = new Chartist.Line('.ct-chart', {
    labels: Array(maxPoints).fill(''),
    series: [Array(maxPoints).fill(0)],
  }, {
    showPoint: false,
    lineSmooth: false,
    axisY: {
      onlyInteger: true,
      low: -2,
      high: 2
    }
  })

  // Обновление данных каждые 200 мс
  interval = setInterval(async () => {
    try {
      const res = await fetch(API_URL)
      const json = await res.json()
      const value = json.ay?.toFixed(2) ?? 0

      if (data.length >= maxPoints) {
        data.shift()
        labels.shift()
      }

      data.push(Number(value))
      labels.push('')

      chart.update({
        labels: labels,
        series: [data]
      })

    } catch (err) {
      console.error('Ошибка получения данных', err)
    }
  }, 200)
})

onBeforeUnmount(() => {
  clearInterval(interval)
})
</script>

<style scoped>
.ct-chart {
  height: 300px;
}
</style>
